module.exports = __webpack_public_path__ + "img/logo-codata-branco.939028c5.png";